import { render, staticRenderFns } from "./Newsroom.vue?vue&type=template&id=6f68f6de&scoped=true&"
import script from "./Newsroom.vue?vue&type=script&lang=js&"
export * from "./Newsroom.vue?vue&type=script&lang=js&"
import style0 from "./Newsroom.vue?vue&type=style&index=0&id=6f68f6de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f68f6de",
  null
  
)

export default component.exports